module.exports = __webpack_public_path__ + "ui/img/teambot-logo-mid-centered-alpha.56149fe6.png";